/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/2016
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Public from 'components/PublicPage';
import Terms from 'components/TermsPage';

type Store = {
  dispatch: Function,
  getState: Function,
  replaceReducer: Function,
  subscribe: Function,
};

type Props = {
  store: Store,
};

/**
 * Defines the app's root component and router. Also makes Redux store
 * available to all sub-components
 */
const Root = ({ store }: Props) => (
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/map/:inventory/:scenario" component={Public} />
        <Route path="/terms" component={Terms} />
        <Redirect from="/" to="/map/tallBuilding/hayward" />
      </Switch>
    </Router>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./js/components/Root.jsx